export default {
  // 標籤頁
  saveToNewCase: "保存畫布至新案件",
  saveToExistingCase: "畫布保存至已有案件",
  
  // 表單標籤
  caseName: "案件名稱",
  caseType: "案件類型",
  caseTypeName: "案件類型名稱",
  policeType: "警種",
  caseDescription: "案件說明",
  canvasName: "畫布名稱",
  case: "案件",
  
  // 占位符
  pleaseEnterCaseName: "請輸入案件名稱(必填)",
  pleaseSelectCaseType: "請選擇案件類型(必填)",
  pleaseSelectCaseTypeName: "請選擇案件類型名稱",
  pleaseEnterPoliceType: "請輸入警種",
  pleaseEnterCaseDescription: "請輸入案件說明",
  pleaseEnterCanvasName: "請輸入畫布名稱",
  pleaseSelectCase: "請選擇案件",
  
  // 按鈕
  reset: "重置",
  saveCanvas: "保存畫布",
  
  // 驗證消息
  caseNameRequired: "案件名稱為必填項",
  caseNameLength: "長度在 1 到 20個字符",
  caseTypeRequired: "請選擇案件類型",
  caseRequired: "請選擇案件",
  descriptionLength: "長度在 1 到 200個字符",
  canvasNameRequired: "畫布名稱為必填項",
  canvasNameLength: "長度在 1 到 20個字符",
  
  // 成功消息
  saveSuccess: "保存畫布成功",
};
